import { render, staticRenderFns } from "./UnitsExplanation.vue?vue&type=template&id=34037aac&scoped=true&"
import script from "./UnitsExplanation.vue?vue&type=script&lang=ts&"
export * from "./UnitsExplanation.vue?vue&type=script&lang=ts&"
import style0 from "./UnitsExplanation.vue?vue&type=style&index=0&id=34037aac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34037aac",
  null
  
)

export default component.exports